import './App.css';
// import Header from "./Header";
// import Nav from "./Nav";
// import Main from "./Main";
// import Footer from "./Footer";
import { Routes, Route } from "react-router-dom";
import Homepage from "./Homepage";
import Reservations from "./BookingPage";
import ConfirmedBooking from './ConfirmedBooking';

import { useReducer, useEffect } from "react";

function App() {
  const styles = {
    "*": {
      boxSizing: "border-box",
      margin: 0,
      padding: 0,
    },

    body: {
      maxWidth: 1200,
      margin: "0px auto",
    },
  };

  const fetchAPI = (date) => {
    // Mock implementation; replace with actual API call
    let result = [];
    let random = seededRandom(date.getDate());
  
    for (let i = 17; i <= 23; i++) {
      if (random() < 0.5) {
        result.push(i + ':00');
      }
      if (random() < 0.5) {
        result.push(i + ':30');
      }
    }
    return result;
  }
  
  const seededRandom = function (seed) {
    var m = 2**35 - 31;
    var a = 185852;
    var s = seed % m;
    return function () {
      return (s = s * a % m) / m;
    };
  }
  
  const updateTimes = (state, action) => {
    if (action.type === 'UPDATE_TIMES') {
      const times = fetchAPI(new Date(action.date));
      return times;
    }
    return state;
  };
 
  const [availableTimes, dispatch] = useReducer(updateTimes, []);
  // const navigate = useNavigate();

  useEffect(() => {
    const today = new Date().toLocaleDateString('en-CA');
    dispatch({ type: 'UPDATE_TIMES', date: today });
  }, []);

  // const submitForm = (formData) => {
  //   // Mock submission, replace with actual submission logic
  //   const result = true; // Simulate successful submission
  //   if (result) {
  //     return formData;
  //     navigate('/confirmed');
  //   }
  // };


  // ----------------------------------

// 1.STUDY PROS AND CONS
// 2.SUBJECT VS SUBJECT

  // ----------------------------------

  const submitForm = (formData, navigate) => {
    const result = true; // Simulate successful submission
    if (result) {
      navigate('/confirmed', { state: { ...formData } });
    }
  };

  return (
   <>

   {/* 
   https://medium.com/@a.g.stranger/4-different-ways-you-can-wrap-react-components-38b02302b07d
    <Header>
      <Nav/>
    </Header> 
    */}



    {/* <Header>
    <Nav />
    </Header>


    <Main/>
    <Footer/> */}


    <div style={styles}>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/confirmed" element={<ConfirmedBooking />} />

        {/* WRONG: PASSING PROP */}
        {/* <Route path="/reservations" availableTimes={availableTimes} dispatch={dispatch} submitForm={submitForm}  element={<Reservations />} /> */}

        {/* CORRECTED: */}
        <Route path="/reservations"  element={<Reservations availableTimes={availableTimes} dispatch={dispatch} submitForm={submitForm} />} />


      </Routes>
    </div>
    </>
  );
} 
export default App;

